//New component for sharing surveys, calls new endpoint, so responses processing is handled on backend side
import React, { Component } from "react";
// import "survey-react/survey.css";
// import "survey-core/defaultV2.css";
import "survey-react/modern.css";
import "./take-survey-recruitment.css";
import * as Survey from "survey-react";
import { connect } from "react-redux";
import { getSingleSurveyThunk, saveResponsesThunk } from "../../../redux/survey/survey.thunk";
import { Alert, Box, Button, Container, TextField, Typography } from "@mui/material";
import { MutatingDots } from "react-loader-spinner";
import { palette } from "../../../assets/styles/theme";
import { withParams } from "../../../helpers/with-params";
import {
    evaluateResponsesDevService,
    checkEvaluationDevService,
    getApplicantDevService,
    getRealEvaluationScore,
    PASSING_THRESHOLD
} from "../../../services/survey-recruitment.service";
import SurveyCompetencies
    from "../../../charts/components/main/SurveyDashboardOverview/SurveyCompetencies";
import SurveyValuesProfile
    from "../../../charts/components/main/SurveyDashboardOverview/SurveyValuesProfile";
import SurveyEQ24M
    from "../../../charts/components/main/SurveyDashboardOverview/SurveyEQ24M";

// Translate the required error message
Survey.surveyLocalization.locales["en"].requiredError = "La respuesta es obligatoria";


class RespondSurveyRecruitment extends Component {

    constructor(props) {
        super(props);
        this.survey = null;
        this.originalTitle = document.title;
        this.originalFavicon = document.getElementById('favicon')?.href;
    }

    state = {
        loaded: false,
        checkingStatus: true,
        survey: {},
        user: {
            firstName: null,
            lastName: null,
            email: null,
            id: null,
            tenantId: null,
        },
        applicant_id: null,
        applicant: null,
        lng: 'en',
        surveyCompleted: false,
        saving: false,
        surveyResponses: null,
        evaluationResults: null,
        dummyDataSurveyIds: ["0a266c4e-57f6-44b5-bb97-ec6be82cb138", "0aac0111-4931-4852-a70b-890624265507"],
        isApproved: false,
        finalScore: null,
        isValuesProfileSurvey: false,
        userName: '',
        nameSubmitted: false,
        countdown: 5,
        countdownInterval: null
    };

    startAutoCloseCountdown = (seconds = 5) => {
        if (this.state.countdownInterval) {
            clearInterval(this.state.countdownInterval);
        }
        this.setState({ countdown: seconds });
        const interval = setInterval(() => {
            this.setState(prevState => {
                if (prevState.countdown <= 1) {
                    clearInterval(interval);
                    try {
                        window.close();
                    } catch (e) {
                        console.warn("Could not auto-close browser window:", e);
                    }
                    return { countdown: 0, countdownInterval: null };
                }
                return { countdown: prevState.countdown - 1 };
            });
        }, 1000);
        this.setState({ countdownInterval: interval });
    };

    async componentDidMount() {
        document.title = "Moodbit | Test Psicolaboral";
        const favicon = document.getElementById('favicon');
        if (favicon) {
            favicon.href = `${process.env.PUBLIC_URL}/talent-match.png`;
        }

        const { id, applicant_id } = this.props.params;
        this.setState({ applicant_id });
        this.props.getSingleSurvey(id);

        if (applicant_id) {
            try {
                const tempApplicant = await getApplicantDevService(applicant_id);
                if (tempApplicant?.preference_language) {
                    this.setState({ lng: tempApplicant.preference_language, applicant: tempApplicant });
                }
            } catch (applicantErr) {
                console.warn("Could not fetch applicant details:", applicantErr);
            }

            // Fast status check directly from backend database
            try {
                const checkData = await checkEvaluationDevService(applicant_id);
                if (checkData && checkData.completed) {
                    this.setState({
                        surveyCompleted: true,
                        isApproved: checkData.approved,
                        checkingStatus: false,
                        loaded: true
                    });
                    this.startAutoCloseCountdown(5);
                    return;
                }
            } catch (error) {
                console.warn("Could not verify prior evaluation status:", error);
            }
        }
        this.setState({ checkingStatus: false });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.singleSurvey && this.props.singleSurvey.id !== prevProps.singleSurvey.id) {
            this.survey = new Survey.Model(this.props.singleSurvey.json);

            this.survey.completeText = 'Submit';
            this.survey.pagePrevText = 'Previous';
            this.survey.pageNextText = 'Next';
            Survey.surveyLocalization.locales["en"].requiredError = 'The answer is required';

            // Apply modern survey theme
            Survey.StylesManager.applyTheme("modern");

            this.survey.onComplete.add(this.surveyCompleted);
            this.setState({ loaded: true, isValuesProfileSurvey: this.props.singleSurvey.id === "0aac0111-4931-4852-a70b-890624265507" });
        }
    }

    componentWillUnmount() {
        document.title = this.originalTitle;
        const favicon = document.getElementById('favicon');
        if (favicon) {
            favicon.href = this.originalFavicon;
        }
        if (this.state.countdownInterval) {
            clearInterval(this.state.countdownInterval);
        }
    }

    surveyCompleted = async (sender, options) => {
        console.log(sender.data);

        this.setState({ saving: true });
        options.showDataSaving();

        const surveyId = this.props.singleSurvey.id;

        function toString(o) {
            Object.keys(o).forEach(k => {
                if (typeof o[k] === 'object') {
                    return toString(o[k]);
                }
                o[k] = '' + o[k];
            });
            return o;
        }

        const responses = toString(sender.data);
        console.log(responses);

        let userId;
        if (this.state.isValuesProfileSurvey) {
            userId = `${this.state.userName}_${crypto.randomUUID()}`;
        } else {
            userId = this.state.applicant_id ? this.state.applicant_id : crypto.randomUUID();
        }

        let resDisc = null;
        let finalScore = null;
        let isApproved = false;

        try {
            // Single API call: Backend calculates approval and asynchronously handles background tasks
            resDisc = await evaluateResponsesDevService(surveyId, responses, this.state.applicant_id);
            console.log('Evaluation result from backend (DEV):', resDisc);

            finalScore = getRealEvaluationScore(resDisc);
            isApproved = resDisc && typeof resDisc.approved === 'boolean' 
                ? resDisc.approved 
                : (finalScore !== null ? finalScore >= PASSING_THRESHOLD : false);
            console.log(`Evaluation processed (DEV): isApproved=${isApproved}, score=${finalScore}`);
        } catch (error) {
            console.warn('Backend evaluation failed or not reachable (DEV):', error);
        }

        let res = await this.props.saveResponses(surveyId, responses, userId);
        console.log(res);

        if (res === 201) {
            options.showDataSavingSuccess();
            this.setState({
                surveyCompleted: true,
                surveyResponses: responses,
                evaluationResults: resDisc,
                isApproved: isApproved,
                finalScore: finalScore,
                saving: false
            });
            this.startAutoCloseCountdown(5);
        } else if (res === 500) {
            options.showDataSavingError();
            this.setState({ saving: false });
        } else {
            this.setState({
                surveyCompleted: true,
                surveyResponses: responses,
                evaluationResults: resDisc,
                isApproved: isApproved,
                finalScore: finalScore,
                saving: false
            });
            this.startAutoCloseCountdown(5);
        }
    };

    handleNameSubmit = (e) => {
        e.preventDefault();
        if (this.state.userName.trim()) this.setState({ nameSubmitted: true });
    }

    render() {
        if (this.state.surveyCompleted) {
            if ("e48f3164-bff8-4886-8232-aa80f7a44002" === this.props.singleSurvey.id && this.state.surveyResponses) {
                return (<SurveyEQ24M survey={this.props.singleSurvey} responses={this.state.surveyResponses} applicantId={this.state.applicant_id} evaluationResults={this.state.evaluationResults} />)
            }
            if ("0a266c4e-57f6-44b5-bb97-ec6be82cb138" === this.props.singleSurvey.id) {
                return (<SurveyCompetencies survey={this.props.singleSurvey} />)
            }
            if ("0aac0111-4931-4852-a70b-890624265507" === this.props.singleSurvey.id && this.state.surveyResponses) {
                return (<SurveyValuesProfile survey={this.props.singleSurvey} responses={this.state.surveyResponses} />)
            }

            // Unified corporate neutral completion view
            const isEnglish = this.state.lng === 'en';
            return (
                <div className="survey-completed-container" style={{ textAlign: 'center', marginTop: '8vh', maxWidth: 650, marginInline: 'auto', padding: '0 20px' }}>
                    <div style={{ fontSize: '3.5rem', marginBottom: 16 }}>📋</div>
                    <h2 style={{ color: '#1A237E', fontWeight: 700, fontSize: '2.2rem', marginBottom: 16 }}>
                        {isEnglish ? 'Thank you for completing the assessment!' : '¡Muchas gracias por completar la evaluación!'}
                    </h2>
                    <p style={{ color: '#4A5568', fontSize: '1.2rem', lineHeight: '1.6', marginBottom: 24 }}>
                        {isEnglish
                            ? 'We have received your responses successfully. Our recruitment team will review the information and contact you shortly.'
                            : 'Hemos recibido tus respuestas exitosamente. Nuestro equipo revisará la información y nos pondremos en contacto contigo a la brevedad.'}
                    </p>
                    <p style={{ color: '#2B6CB0', fontWeight: 600, fontSize: '1.05rem', marginBottom: 20 }}>
                        {this.state.countdown > 0 
                            ? (isEnglish 
                                ? `This window will close automatically in ${this.state.countdown} seconds...` 
                                : `Esta ventana se cerrará automáticamente en ${this.state.countdown} segundos...`)
                            : (isEnglish ? 'You may now close this window.' : 'Ya puedes cerrar esta ventana.')}
                    </p>
                    <button
                        onClick={() => window.close()}
                        style={{
                            display: 'inline-block',
                            padding: '12px 28px',
                            backgroundColor: '#1A237E',
                            color: '#fff',
                            borderRadius: 8,
                            fontWeight: 600,
                            fontSize: '1rem',
                            border: 'none',
                            cursor: 'pointer',
                            boxShadow: '0px 4px 12px rgba(26,35,126,0.15)',
                            marginBottom: 16,
                            transition: 'background 0.3s'
                        }}
                    >
                        {isEnglish ? 'Close window' : 'Cerrar ventana'}
                    </button>
                    <p style={{ color: '#718096', fontSize: '0.85rem' }}>
                        {isEnglish 
                            ? 'If the window does not close automatically, you can close it manually.' 
                            : 'Si la ventana no se cierra automáticamente, puedes cerrarla manualmente.'}
                    </p>
                </div>
            );
        }

        if (this.state.isValuesProfileSurvey && !this.state.nameSubmitted && this.state.loaded) {
            return (
                <Container component="main" maxWidth="sm" sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                }}>
                    <Box
                        sx={{
                            p: 4,
                            borderRadius: 2,
                            boxShadow: 3,
                            backgroundColor: 'background.paper',
                            textAlign: 'center',
                            width: '100%'
                        }}
                    >
                        <Typography component="h1" variant="h5" gutterBottom>
                            {/*{this.props.t('welcome')}*/}
                            {'Welcome'}
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                            {/*{this.props.t('enterFullName')}*/}
                            {'Please enter your full name to begin.'}
                        </Typography>
                        <Box component="form" onSubmit={this.handleNameSubmit} noValidate sx={{ mt: 1 }}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="name"
                                label={'Full Name'}
                                name="name"
                                autoComplete="name"
                                autoFocus
                                value={this.state.userName}
                                onChange={(e) => this.setState({ userName: e.target.value })}
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2, py: 1.5 }}
                            >
                                {/*{this.props.t('continue')}*/}
                                {'Continue'}
                            </Button>
                        </Box>
                    </Box>
                </Container>
            )
        }
        return (
            <div>
                <div>
                    {this.state.loaded ? (
                        <div>

                            {!this.props.singleSurvey.active ?
                                <Alert severity="warning" sx={{ width: '100%' }}>
                                    {this.props.t('survey.stopResponses')}
                                </Alert> :
                                <div>

                                    {this.state.saving ?
                                        (
                                            <div className="d-flex justify-content-center">
                                                <MutatingDots
                                                    color={palette.primary}
                                                    height="100"
                                                    width="100"
                                                    visible={true} />
                                            </div>
                                        )
                                        :
                                        <div className="survey-container notranslate" translate="no">
                                            <Survey.Survey model={this.survey} />
                                        </div>

                                    }
                                </div>
                            }
                        </div>
                    ) : null}
                    <div>
                        <div className="d-flex justify-content-center">
                            <MutatingDots
                                color={palette.primary}
                                height="100"
                                width="100"
                                visible={!this.state.loaded} />
                        </div>
                        {!this.state.loaded ? <p className="text-center">{this.props.t('status.loading')}... </p> : null}
                    </div>
                </div>
            </div>
        );
    }
}

// Map state to props;
const mapStateToProps = (state) => {
    return {
        singleSurvey: state.surveys.singleSurvey,
        surveyStatus: state.surveys.status,
    };
};

// Map dispatch to props;
const mapDispatchToProps = (dispatch) => {
    return {
        getSingleSurvey: (id) => dispatch(getSingleSurveyThunk(id)),
        saveResponses: (surveyId, responses, userId) => dispatch(saveResponsesThunk(surveyId, responses, undefined, userId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withParams(RespondSurveyRecruitment));
